import { useIntl } from 'react-intl';

import Button from '@atlaskit/button';

import { usePipelineRunHistoryContext } from 'src/components/pipelines/contexts/pipeline-run-history-context';

import { PreviousRunMessageCard, WarningMessageWrapper } from '../styled';

import { messages } from './PreviousRunMessage.i18n';

export const PreviousRunMessage = () => {
  const { formatMessage } = useIntl();
  const { onSelectRun, pipelineRuns } = usePipelineRunHistoryContext();

  return (
    <PreviousRunMessageCard>
      <WarningMessageWrapper>
        {formatMessage(messages.previousRunMessageText)}
      </WarningMessageWrapper>
      <Button
        spacing="none"
        appearance="link"
        onClick={() => {
          onSelectRun(pipelineRuns[0], true);
        }}
      >
        {formatMessage(messages.previousRunMessageLink)}
      </Button>
    </PreviousRunMessageCard>
  );
};
